"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateFundraiseRoundSchema = void 0;
const moment_1 = __importDefault(require("moment"));
const yup = __importStar(require("yup"));
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const GOAL_VALUE_MAX = "Goal value can not exceed $999,999,999.99";
const VALID_CLOSE_DATE = "Please enter a valid closed date";
const CLOSE_DATE_NOT_BEFORE_OPEN = "Close date cannot be before the open date";
const CLOSE_DATE_NOT_FUTURE = "Close date cannot be in the future";
exports.UpdateFundraiseRoundSchema = yup.object().shape({
    goal: yup
        .number()
        .typeError("Goal value should be at least $0.00")
        .min(0.0, "Goal value should be at least $0.00")
        .when("$isDollar", ([isDollar], schema) => isDollar ? schema.max(999999999.99, GOAL_VALUE_MAX) : schema.max(99999999999.0, GOAL_VALUE_MAX)),
    status: yup.string(),
    closeDate: yup
        .string()
        .nullable()
        .when("status", {
        is: "Closed",
        then: () => yup
            .string()
            .required(VALID_CLOSE_DATE)
            .test("validDate", VALID_CLOSE_DATE, (closeDate) => (0, moment_1.default)(closeDate).isValid() && (0, mystake_common_sdk_1.getDateYear)(closeDate) > 1920)
            .when("$openDate", ([openDate], schema) => schema
            .test("validDate", CLOSE_DATE_NOT_BEFORE_OPEN, (closeDate) => (0, moment_1.default)(closeDate).isAfter((0, moment_1.default)(openDate).subtract(1, "days")))
            .test("validDate", CLOSE_DATE_NOT_FUTURE, (closeDate) => (0, moment_1.default)(closeDate).isBefore((0, moment_1.default)()))),
    }),
});
//# sourceMappingURL=UpdateFundraiseRoundSchema.js.map